const loadingLabel = "Laster";
const nbNO = {
  loadingLabel
};
export {
  nbNO as default,
  loadingLabel
};
